import React from 'react';

const ChartLoading = () => {
  return (
    <div className="gx-text-center">
      Loading...
    </div> 
  );
}

export default ChartLoading;